import React from "react";

/**
 * Marquee
 * A CSS-only infinite horizontal marquee that seamlessly loops.
 * Duplicates its children twice so the translation never "jumps".
 * Use for tech keyword tickers, tagline rails, etc.
 */
export default function Marquee({
  items = [],
  speed = 40,
  className = "",
  separator = "\u2022"
}) {
  const row = (
    <div className="flex items-center gap-10 pr-10 shrink-0">
      {items.map((label, i) => (
        <span key={i} className="flex items-center gap-10 shrink-0">
          <span className="whitespace-nowrap">{label}</span>
          <span className="text-brand-600/50" aria-hidden="true">
            {separator}
          </span>
        </span>
      ))}
    </div>
  );

  return (
    <div
      className={`group relative overflow-hidden ${className}`}
      aria-label="Scrolling keywords"
    >
      {/* edge fades */}
      <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-white to-transparent z-10" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-white to-transparent z-10" />

      <div
        className="flex w-max"
        style={{
          animation: `marquee-x ${speed}s linear infinite`,
          animationPlayState: "running"
        }}
      >
        {row}
        {row}
      </div>
    </div>
  );
}
